/** @jsx jsx */
import { useState } from 'react';
import { jsx } from 'theme-ui';
import { ChevronDown, ChevronUp } from '../Icons';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export const getDefaultValue = ({
  defaultValue,
  type,
  flowType
}) => {
  const propType = flowType ? flowType : type;
  if (!defaultValue || !defaultValue.value) return null;

  if (defaultValue.value === "''") {
    return '[Empty string]';
  }

  if (propType && propType.name === 'string') {
    return defaultValue.value.replace(/\'/g, '"');
  }

  if (typeof defaultValue.value === 'object' && defaultValue.value.toString) {
    return defaultValue.value.toString();
  }

  return defaultValue.value;
};

if (typeof getDefaultValue !== 'undefined' && getDefaultValue && getDefaultValue === Object(getDefaultValue) && Object.isExtensible(getDefaultValue) && !getDefaultValue.hasOwnProperty('__filemeta')) {
  Object.defineProperty(getDefaultValue, '__filemeta', {
    configurable: true,
    value: {
      name: "getDefaultValue",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Props/index.js"
    }
  });
}

export const Prop = ({
  propName,
  prop,
  getPropType,
  isToggle
}) => {
  const {
    0: showing,
    1: setShowing
  } = useState(isToggle || false);
  if (!prop.type && !prop.flowType) return null;

  const toggle = () => setShowing(s => !s);

  return jsx("div", {
    sx: styles.line,
    "data-testid": "prop"
  }, jsx("div", {
    sx: styles.content
  }, jsx("div", {
    sx: styles.propName,
    "data-testid": "prop-name"
  }, propName), jsx("div", {
    sx: styles.propType,
    "data-testid": "prop-type"
  }, getPropType(prop)), prop.defaultValue && jsx("div", {
    sx: styles.defaultValue,
    "data-testid": "prop-default-value"
  }, jsx("em", null, getDefaultValue(prop))), jsx("div", {
    sx: styles.right
  }, prop.required && jsx("div", {
    sx: styles.propRequired,
    "data-testid": "prop-required"
  }, jsx("strong", null, "required")), prop.description && jsx("button", {
    sx: styles.openDescBtn,
    onClick: toggle,
    "data-testid": "prop-toggle-description"
  }, showing ? jsx(ChevronUp, {
    size: 20
  }) : jsx(ChevronDown, {
    size: 20
  })))), showing && prop.description && jsx("div", {
    sx: styles.description,
    "data-testid": "prop-description"
  }, prop.description));
};

if (typeof Prop !== 'undefined' && Prop && Prop === Object(Prop) && Object.isExtensible(Prop) && !Prop.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Prop, '__filemeta', {
    configurable: true,
    value: {
      name: "Prop",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Props/index.js"
    }
  });
}

export const Props = ({
  props,
  getPropType,
  isToggle
}) => {
  const entries = Object.entries(props);
  return jsx("div", {
    sx: styles.container,
    "data-testid": "props"
  }, entries.map(([key, prop]) => jsx(Prop, {
    key: key,
    propName: key,
    prop: prop,
    getPropType: getPropType,
    isToggle: isToggle
  })));
};

if (typeof Props !== 'undefined' && Props && Props === Object(Props) && Object.isExtensible(Props) && !Props.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Props, '__filemeta', {
    configurable: true,
    value: {
      name: "Props",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Props/index.js"
    }
  });
}